__webpack_require__.p = "https://ikea.marat.qd.je/ch/en/customer-service/support/";